import * as Yup from 'yup'

import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'
import { formValidationSchemaNoChanged } from '../../Form'

import {
  USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_FIRST_NAME,
  USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_LAST_NAME,
} from './UserEditUsernameFormModal.constants'

export function getUserEditUsernameFormModalValidationSchema(initialValues) {
  return Yup.object({
    [USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_FIRST_NAME]: Yup.string()
      .ensure()
      .required(true),
    [USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_LAST_NAME]: Yup.string().ensure(),
  }).concat(formValidationSchemaNoChanged({ initialValues }))
}

export function getUserEditUsernameFormModalSubmitPayload(values) {
  return {
    [USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_FIRST_NAME]:
      values[USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_FIRST_NAME],
    [USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_LAST_NAME]:
      values[USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_LAST_NAME],
  }
}

export function getUserEditUsernameFormModalInitialValues(userData) {
  return {
    [USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_FIRST_NAME]:
      userData?.first_name ?? FORMIK_EMPTY_VALUE,
    [USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_LAST_NAME]:
      userData?.last_name ?? FORMIK_EMPTY_VALUE,
  }
}
